import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import colorTypeHelper from 'utils/colorTypeHelper';

export const SectionDescriptionWithImage = props => {
  const { cta, reversed, backgroundColor } = props;
  const bgColor = colorTypeHelper[backgroundColor];

  return (
    <MainDiv bgColor={bgColor} reversed={reversed}>
      <InnerContainer reversed={reversed}>
        <MobileTitle>{props.titlePart}</MobileTitle>
        <ContentRow
          className="section-description-with-image--main"
          type="flex"
          justify="center"
          align="middle"
          gutter={20}
          reversed={reversed}
        >
          <Col className="image" lg={13} md={24} sm={24}>
            {props.imagePart}
          </Col>
          <Col lg={11} md={24} sm={24}>
            <DesktopTitle>{props.titlePart}</DesktopTitle>
            <DescriptionRow gutter={40}>
              <Col lg={24} md={8} sm={24} xs={24}>
                {props.descriptionOnePart}
              </Col>
              <Col lg={24} md={8} sm={24} xs={24}>
                {props.descriptionTwoPart}
              </Col>
              <Col lg={24} md={8} sm={24} xs={24}>
                {props.descriptionThreePart}
              </Col>
              {cta}
            </DescriptionRow>
            <DescriptionAdditional>{props.descriptionAdditionalPart}</DescriptionAdditional>
          </Col>
        </ContentRow>
      </InnerContainer>
    </MainDiv>
  );
};

SectionDescriptionWithImage.propTypes = {
  reversed: PropTypes.bool, // if false: right: text component, left: Video or Image Component
  backgroundImg: PropTypes.string, // background image
  backgroundColor: PropTypes.string,
};

SectionDescriptionWithImage.defaultProps = {
  reversed: false,
};

const MainDiv = styled.div`
  background: ${props =>
    !props.reversed
      ? 'linear-gradient(90deg, ' + `var(${props.bgColor})` + ' 65%, transparent 65%)'
      : 'linear-gradient(90deg, transparent 35%, ' + `var(${props.bgColor})` + ' 35%)'};

  @media (max-width: 991px) {
    background: ${props => props.backgroundColor};
  }
  margin-bottom: 90px;
`;

const InnerContainer = styled.div`
  width: 100%;
  max-width: 1152px;
  margin: 0px auto;
  padding: 75px 28px;
  position: relative;
  overflow: hidden;

  .section-description-with-image--main {
    & > .ant-col:last-child {
      padding-right: ${props => (!props.reversed ? '50px !important' : '10px')};
      padding-left: ${props => (props.reversed ? '50px !important' : '10px')};
    }
  }

  @media (max-width: 991px) {
    padding: 74px 68px 64px;

    .ant-col {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .section-description-with-image--main {
      & > .ant-col:last-child {
        padding-right: 10px !important;
        padding-left: 10px !important;
      }
    }
    .image {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding: 60px 20px 50px;
    background: var(--neutral-1);
  }
`;

const ContentRow = styled(Row)`
  flex-direction: ${props => (props.reversed ? 'row' : 'row-reverse')} !important;

  @media (max-width: 991px) {
    flex-direction: row;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const MobileTitle = styled.div`
  display: none;
  & > div {
    text-align: center;

    h2 {
      font-size: 36px;
      color: var(--neutral-7);
    }

    p {
      font-size: 22px;
    }
  }

  @media (max-width: 991px) {
    display: block;
  }

  @media (max-width: 575px) {
    & > div {
      h2 {
        font-size: 32px;
        padding-top: 20px;
      }

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }
  }
`;

const DesktopTitle = styled.div`
  display: block;

  & > div {
    h2 {
      font-size: 49px;
      color: var(--neutral-7);
    }

    p {
      font-size: 20px;
    }
  }

  @media (max-width: 991px) {
    display: none;
  }
`;

const DescriptionRow = styled(Row)`
  .ant-col > div {
    & > div:nth-child(2) {
      & > p {
        font-size: 20px;
      }
    }
  }

  .button--button {
    margin-top: 30px;
    @media (max-width: 991px) {
      margin: 30px auto 0px;
    }
  }

  @media (max-width: 991px) {
    .ant-col > div {
      flex-direction: column;

      & > div:nth-child(1) {
        & > svg {
          width: 54px;
          height: 54px;
        }
      }

      & > div:nth-child(2) {
        padding-left: 0;

        & > p {
          font-size: 18px;
          line-height: 26px;
          margin-top: 26px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .ant-col {
      & > div {
        & > div:nth-child(2) > p {
          margin-top: 18px;
          text-align: center;
        }
      }
    }
  }
`;

const DescriptionAdditional = styled.div`
  @media (max-width: 991px) {
    text-align: center;
  }
`;
